import { forwardRef } from "react";
import type { TextareaHTMLAttributes } from "react";
import { cn } from "../lib/cn";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
  /** Mostra "12/2000" abaixo quando há `maxLength`. */
  showCount?: boolean;
}

/**
 * Texto longo (sugestão, observação). Mesma borda, raio e foco do `Input` — é o mesmo
 * controle com mais linhas. O contador usa `nums` e fica em `aria-live` educado: avisa sem
 * interromper quem digita.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid = false, showCount = false, maxLength, value, rows = 4, ...props },
  ref,
) {
  const length = typeof value === "string" ? value.length : 0;
  return (
    <div className="flex flex-col gap-1">
      <textarea
        ref={ref}
        rows={rows}
        maxLength={maxLength}
        value={value}
        aria-invalid={invalid || undefined}
        className={cn(
          "w-full resize-y rounded-input border bg-surface px-3.5 py-2.5 text-sm text-foreground",
          "placeholder:text-subtle-foreground",
          "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-3 focus-visible:ring-ring/35",
          "disabled:cursor-not-allowed disabled:bg-muted disabled:text-subtle-foreground",
          invalid
            ? "border-danger focus-visible:border-danger focus-visible:ring-danger/25"
            : "border-border hover:enabled:border-border-strong",
          className,
        )}
        {...props}
      />
      {showCount && maxLength ? (
        <span aria-live="polite" className="self-end text-2xs tabular-nums text-muted-foreground">
          {length}/{maxLength}
        </span>
      ) : null}
    </div>
  );
});
